import { render, staticRenderFns } from "./fragment-table.vue?vue&type=template&id=731e93fe&scoped=true&"
import script from "./fragment-table.vue?vue&type=script&lang=js&"
export * from "./fragment-table.vue?vue&type=script&lang=js&"
import style0 from "./fragment-table.vue?vue&type=style&index=0&id=731e93fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e93fe",
  null
  
)

export default component.exports